module.exports = __webpack_public_path__ + "static/z16-2-0004-tablet-8c831b75485680ea142724de78f7cbf9.jpg";